/**
 * @generated SignedSource<<500938f9cbbcf6a1a6ab1990743ae732>>
 * @relayHash 1e4df8f15ee51482220e9971f54a99b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9d260aae0a2706428fd982165896117974e46f297dd9c6c30eca72dd15f3ecb1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import includeUserAccessEnabledForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access-enabled.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';
import isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider from '@atlassian/jira-relay-provider/src/nike-chin-migrate-multi-select-edit-view-deprecated.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9d260aae0a2706428fd982165896117974e46f297dd9c6c30eca72dd15f3ecb1",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessenabledrelayprovider": includeUserAccessEnabledForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinmigratemultiselecteditviewdeprecatedrelayprovider": isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider
    }
  }
};

export default node;
